'use strict'

const _ = require('lodash')
// const BaccaratRoadmap = use('App/Support/PlayingCards/BaccaratRoadmap')
const BaccaratRoadmap = require('./BaccaratRoadmap')

class KenoRoadmap extends BaccaratRoadmap {

  constructor() {
    super()
    this.columns = 20
    this.rows = 6
    this.scroll = false
  }

  statistic (value, columns = this.columns, rows = this.rows, scroll = this.scroll) {
    if (_.isEmpty(value)) {
      return []
    }
    let group = {}

    _.forEach(value, (v, k) => {
      _.forEach(v.addition, function (vv, kk) {
        const splitKeyType = _.split(vv, 'x')
        const realKeyType = _.toLower(splitKeyType[0])
        if (!_.has(group, realKeyType)) {
          group[realKeyType] = []
        }
        if (_.has(splitKeyType, '1')) {
          group[realKeyType].push({'winner': splitKeyType[1]})
        }
      })
    })

    _.forEach(group, (v, k) => {
      group[k] = this.bigRoad(v, columns, rows, scroll)
    })

    let winner = _.cloneDeep(value)
    _.map(winner, function (v) {
      let splitKeyType = _.split(v.winner, 'x')
      let value
      if (_.has(splitKeyType, '1')) {
        value = splitKeyType[1]
        if (splitKeyType[1] === 'ETSCORE') {
          value = 'TIE'
        }
        v.winner = value
      }
    })
    group['winner'] = this.bigRoad(winner, columns, rows, scroll)

    let score = _.cloneDeep(value)
    _.forEach(score, (v, k) => {
      score[k].winner = v.score
    })
    group['score'] = this.beadRoad(score, columns, rows, scroll)

    return group
  }
}

module.exports = KenoRoadmap



// WEBPACK FOOTER //
// ./app/Support/PlayingCards/KenoRoadmap.js